import type { MarketVariants } from '@/lib/i18n'

export type Slide4BridgeCopy = {
  headline: string
}

export const copy: MarketVariants<Slide4BridgeCopy> = {
  US: {
    headline: 'Let’s take a look at a few real-world examples.',
  },
  ar: {
    headline: 'لنلقِ نظرة على بعض الأمثلة من الواقع.',
  },
}
